import React from 'react';
import PropTypes from 'prop-types';
import ExternalModal from '../Modals/ExternalModal';
import _ from 'lodash';

const CallToAction = props => {
  const tracking = props.tracking || '';
  const callToActionList = [
    {
      id: 1,
      text: [<p key="0">If you have any questions regarding Terms and Conditions or claims processing, please contact the <b>McKesson Customer Service Center</b> at <b><span className='nowrap-txt'>1-855-902-6725</span>, Monday-Friday, 8AM-8PM ET.</b> </p>],
    },
    {
      id: 2,
      text: [<p key="0">There may be other financial assistance programs available to you through Takeda Oncology Here2Assist&reg;. If you need more information or want to discuss your eligibility, please contact <b>Takeda Oncology Here2Assist</b> at <b><span className='nowrap-txt'>1-844-817-6468</span>, Option 2, Monday-Friday, 8AM-8PM ET</b> or visit <ExternalModal url="https://www.here2assist.com/" trigger={ <a className={ tracking } rel="noopener noreferrer"><b>www.Here2Assist.com</b></a> }/>.</p>],
    },
    {
      id: 3,
      text: [<p key="0">There may be other financial assistance programs available to your patient through Takeda Oncology Here2Assist&reg;. If you or your patient needs more information or wants to discuss eligibility, please contact <b>Takeda Oncology Here2Assist</b> at <b><span className='nowrap-txt'>1-844-817-6468</span>, Option 2, Monday-Friday, <span className='nowrap-txt'>8AM-8PM ET</span></b> or visit <ExternalModal url="https://www.here2assist.com/" trigger={ <a className={ tracking } rel="noopener noreferrer"><b>www.Here2Assist.com</b></a> }/>.</p>],
    },
    {
      id: 4,
      text: [<p key="0" className="need-help-text">Need help finding your co-pay card&nbsp;details? <br/> Give us a call at <b>1&#8209;844&#8209;817&#8209;6468, Option 2,</b> for&nbsp;support.</p>],
    },
    {
      id: 4.5,
      text: [<p key="0" className="need-help-text">If you need assistance, please contact <b>Takeda Oncology Here2Assist&reg;</b> at <b><span className='nowrap-txt'>1-844-817-6468</span>, Option 2, Monday-Friday, <span className='nowrap-txt'>8AM-8PM ET</span>.</b></p>],
    },
    {
      id: 5,
      text: [<p key="0">Please contact <b>Takeda Oncology Here2Assist</b> at <b><span className='nowrap-txt'>1-844-817-6468</span>, Option 2, Monday-Friday, <span className='nowrap-txt'>8AM-8PM ET</span>.</b></p>],
    },
    {
      id: 6,
      text: [<p key="0">If you or your patient has any questions regarding Terms and Conditions or claims processing, please contact <strong>Takeda Oncology Here2Assist</strong> at <strong><span className='nowrap-txt'>1-844-817-6468</span>, Option 2, Monday-Friday, <span className='nowrap-txt'>8AM-8PM ET</span>.</strong></p>],
    },
    {
      id: 7,
      text: [<p key="0" className="need-help-text right-padding">If you or your patient needs assistance, please contact <b>Takeda&nbsp;Oncology Here2Assist&reg;</b> at <b><span className='nowrap-txt'>1-844-817-6468</span>, Option 2, Monday-Friday, <span className='nowrap-txt'>8AM-8PM ET</span>.</b></p>],
    },
    {
      id: 8,
      text: [<p key="0">If you or your patient is having trouble, please call <b>Takeda Oncology Here2Assist</b> at <b><span className='nowrap-txt'>1-844-817-6468</span>, Option 2, Monday-Friday, <span className='nowrap-txt'>8AM-8PM ET</span>.</b></p>],
    },
    {
      id: 9,
      text: [<p key="0">If you are having trouble, please call <b>Takeda Oncology Here2Assist</b> at <b><span className='nowrap-txt'>1-844-817-6468</span>, Option 2, Monday-Friday, <span className='nowrap-txt'>8AM-8PM ET</span>.</b></p>],
    },
  ];
  const callToActionText = _.find(callToActionList, { id: props.id });
  return (
    <div className={ `call-to-action full-width ${props.customClass ? props.customClass : ''}` }>
      { callToActionText.text }
    </div>
  );
};

CallToAction.propTypes = {
  id: PropTypes.number.isRequired,
  customClass: PropTypes.string,
  tracking: PropTypes.string,
};

export default CallToAction;
